import CartItemRow from "./CartItemRow";

function CartItemList({ cartItems, onQuantityChange, onRemove, onUpdateNote }) {
  return (
    <div className="cart-item-list">
      {cartItems.map((item) => (
        <CartItemRow
          item={item}
          key={`${item.locationSlug}-${item.id}`}
          onQuantityChange={onQuantityChange}
          onRemove={onRemove}
          onUpdateNote={onUpdateNote}
        />
      ))}
    </div>
  );
}

export default CartItemList;
